import { generateReportFleetLoyalty } from "apis/generate-report.api";
import { getVIPRedemptionHistory } from "apis/vip-biz.api";
import { BackLink, Intro } from "components/commons";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { SuccessModal } from "components/modals";
import { FleetContext, UserContext } from "contexts";
import { Path, ReportType, UserAccess } from "enums";
import { useExport } from "hooks";
import useDataTable from "hooks/useDataTable";
import locale from "localization";
import React, { useContext } from "react";
import { redemptionHistoryColumns } from "./redemption-history-columns";
import RedemptionHistoryFilter from "./redemption-history-filter";
import { redemptionHistoryFilterState } from "./redemption-history-filter.state";
import { mapDataToList, mapFilterToRequest } from "./redemption-history.mapper";
import styles from "./redemption-history.module.scss";

const RedemptionHistoryModule = () => {
  const { fleet } = useContext(FleetContext);
  const { userAccess } = useContext(UserContext);
  const { fleetId } = fleet;

  const getUserAccess = userAccess.find((item) => {
    return item.key === UserAccess.VIPRedemptionHistory;
  });

  const { filter, search, table } = useDataTable({
    api: {
      api: getVIPRedemptionHistory,
      params: {
        fleetId,
      },
    },
    filter: { initialState: redemptionHistoryFilterState(), mapper: mapFilterToRequest },
    table: {
      key: "redemptionHistory",
      mapper: mapDataToList,
      columns: redemptionHistoryColumns,
    },
  });

  const exports = useExport({
    api: generateReportFleetLoyalty,
    reportType: ReportType.VIPRedemptionHistory,
    hasModal: true,
    mappedFilterState: {
      ...filter?.mappedFilterState,
      fleetId,
      searchKey: search?.searchKey,
    },
  });

  return (
    <div>
      <SuccessModal {...exports?.successModalComponent} />
      <BackLink text={locale.redeemPoints} path={Path.VIPRedeemPoints} />
      <Intro title={locale.redemptionHistory} />
      <div className={styles.filters}>
        <RedemptionHistoryFilter
          {...filter}
          {...search}
          {...exports}
          getUserAccess={getUserAccess}
        />
      </div>
      <div className={styles.table}>
        <DataTableV2 {...table} />
      </div>
    </div>
  );
};

export default RedemptionHistoryModule;
